import { FC } from 'react';
import { Autocomplete, SxProps, TextField } from '@mui/material';
import { useApiIsLoaded } from '@vis.gl/react-google-maps';
import { useForm } from '@carcareers/contexts';

interface LocationInputProps {
  label: string;
  name: string;
  required?: boolean;
  fullWidth?: boolean;
  autoComplete?: string;
  disabled?: boolean;
  sx?: SxProps;
  cityStateOnly?: boolean;
}

export const LocationInput: FC<LocationInputProps> = ({
  label,
  name,
  required,
  fullWidth,
  autoComplete,
  disabled,
  sx,
  cityStateOnly = false,
}) => {
  const { setData, getData, getErrors } = useForm();

  const apiIsLoaded = useApiIsLoaded();

  const handlePlaceSelect = (place: google.maps.places.PlaceResult) => {
    setData(name, place.formatted_address);
  };

  return (
    apiIsLoaded && (
      <Autocomplete
        id={name}
        options={[]}
        inputValue={getData<string>(name) ?? ''}
        disabled={disabled}
        renderInput={(params) => (
          <TextField
            {...params}
            name={name}
            value={getData<string>(name) ?? ''}
            label={label}
            required={required}
            fullWidth={fullWidth}
            autoComplete={autoComplete}
            error={!!getErrors(name)}
            helperText={getErrors(name)}
            onChange={(e) => {
              setData(name, e.target.value);
            }}
            slotProps={{
              input: {
                sx,
              },
            }}
          />
        )}
        freeSolo
        filterOptions={(x) => x}
        onOpen={() => {
          const input = document.getElementById(name) as HTMLInputElement;
          const autocomplete = new google.maps.places.Autocomplete(input, {
            fields: ['formatted_address', 'geometry', 'address_components'],
            componentRestrictions: { country: 'us' },
            ...(cityStateOnly && { types: ['(cities)'] }),
          });
          autocomplete.addListener('place_changed', () => {
            const place = autocomplete.getPlace();
            handlePlaceSelect(place);
          });
        }}
        sx={{
          width: '100%',
          my: 1,
        }}
      />
    )
  );
};
